import { makeStyles } from '@mui/styles';

export const credentialsStyles = makeStyles(() => ({
    credentialsListWrapper: {
        width: '50%',
        marginRight: '16px',
    },
    credentialsListHeaderBox: {
        padding: '0 4px',
    },
    credentialsListHeader: {
        borderRadius: '8px',
        background: '#EBF2FD',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '16px 32px',
    },
    credentialsListHeaderTitle: {
        color: '#347AF0',
        fontSize: '16px',
        fontWeight: 600,
    },
    coveredCredentialsWrapper: {
        width: '50%',
        borderRadius: '8px',
        boxShadow: '0px 0px 6px 0px rgba(138, 138, 138, 0.24)',
        height: '605px',
    },
    coveredCredentialsHead: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '18px 32px',
    },
    coveredCredentialsHeadTitle: {
        color: '#4B5C68',
        fontSize: '16px',
        fontWeight: '600',
        lineHeight: '24px',
        marginRight: '24px',
    },
    credentialItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '12px 32px',
        borderRadius: '8px',
        boxShadow: '0px 0px 6px 0px rgba(138, 138, 138, 0.24)',
        cursor: 'pointer',
        marginBottom: '8px',
    },
    credentialCoveredItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '12px 32px',
        cursor: 'pointer',
        marginBottom: '4px',
        background: '#F2F4F8',
    },
    licenseTitle: {
        color: '#4B5C68',
        fontSize: '14px',
        marginLeft: '8px',

        '& b': {
            fontWeight: 600,
        },
    },
    credentialActionBox: {
        display: 'flex',
        alignItems: 'center',

        '& button': {
            background: 'transparent',
            border: 'none',
            marginRight: '8px',
        },
    },
    createCredentialWrapper: {
        width: '480px',
    },
    createCredentialBody: {
        margin: '40px 0',
    },
    credentialsListBody: {
        height: '550px',
        overflow: 'auto',
        padding: '8px 6px',
    },
    selectCredential: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',

        '& p': {
            color: '#4B5C68',
            fontSize: '18px',
            fontWeight: '600',
            lineHeight: '24px',
            marginTop: '16px',
        },
    },
    coveredCredentialsBody: {
        height: '470px',
        overflow: 'auto',
    },
    coveredCredentialsSelectWrapper: {
        position: 'relative',
        height: '80px',
    },
    coveredCredentialsSelectBody: {
        position: 'absolute',
        padding: '0 32px 0',
        width: '100%',
        zIndex: 1,
        '@media (max-width: 1280px)': {
            padding: '0 16px 0',
        },
        '& .MuiAutocomplete-paper': {
            borderRight: '1px solid rgba(163, 178, 189, 0.30)',
            borderLeft: '1px solid rgba(163, 178, 189, 0.30)',
            borderTop: '1px solid rgba(163, 178, 189, 0.30)',
            borderRadius: '4px 4px 0 0',
            margin: 0,
        },
        '& .MuiPaper-elevation1': {
            boxShadow: 'none',
            width: '100%',
        },
        '& .MuiAutocomplete-option': {
            padding: '4px 7px',
        },
        '& .MuiAutocomplete-option[aria-selected="true"]': {
            background: '#EBF2FD!important',
        },
        '& .MuiAutocomplete-option[data-focus="true"]': {
            background: '#EBF2FD!important',
        },
    },
}));
